import { Router, NavigationEnd } from '@angular/router';
import { Component, ViewChild } from '@angular/core';
import { AppSettings } from './app.settings';
import { Settings } from './app.settings.model';
import { SpinnerService } from 'src/app/shared-component/services/spinner.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  public settings: Settings;

  constructor(public appSettings: AppSettings,
    public router: Router,
    private spinnerService: SpinnerService) {
    this.settings = this.appSettings.settings;

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        setTimeout(() => {
          const gtagFn = (window as any).gtag as Function | undefined;
          if (typeof gtagFn !== 'function') {
            return;
          }
          switch (location.hostname.toLowerCase()) {
            case "demo.edulinkin.com":
              gtagFn('config', "G-S6EHYC162C", { 'page_path': event.urlAfterRedirects });
              break;
            case "exam.edulinkin.com":
              gtagFn('config', "G-KC1CZ9SF6B", { 'page_path': event.urlAfterRedirects });
              break;          
          }
        }, 1000);
      }
    })
  }

  ngOnInit() {
  }

}